(function() {

    console.log("ENGAGEMENT_RING_EXPIRY_CHECK");

    fetch(`${window.Shopify.routes.root}cart.js`)
    .then(response => response.json())
    .then(cart => {

        let currentTs = Date.now();

        let expiredCartItems = cart.items.filter(item => typeof item.properties._expiry_ts != 'undefined' && currentTs > parseInt(item.properties._expiry_ts));
    
        let removeKeys = expiredCartItems.map(item => item.key);

        if (removeKeys.length < 1) return Promise.resolve(null);

        let updates = {};

        for (let key of removeKeys) {
            updates[key] = 0;
        }

        return fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify({ updates: updates })
        });

    })
    .then((response) => {
        if (!response) return;
        window.location.reload();
    })
    .catch(err => {
        console.log(err);
    });

}());